/** Supported, non-colliding landmarks. Roofless fronts meet map-owned roofs;
 * architecture always renders behind playable surfaces and actors. */
export const RUINS_PROP_TEMPLATES = {
  temple_sanctum_front: { kind: 'gate', name: 'Roofless carved sanctum', frame: { w: 300, h: 660 }, band: 'architecture' },
  temple_inscribed_relief: { kind: 'broken_pillar', name: 'Limestone sun relief', frame: { w: 160, h: 260 }, band: 'architecture' },
  temple_attendant_statue: { kind: 'colonnade_column', name: 'Weathered temple attendant', frame: { w: 150, h: 420 }, band: 'architecture' },
  sunken_aqueduct_front: { kind: 'gate', name: 'Roofless drowned aqueduct', frame: { w: 400, h: 560 }, band: 'architecture' },
  sunken_broken_arch: { kind: 'gate', name: 'Fractured sea arch', frame: { w: 280, h: 360 }, band: 'architecture' },
  sunken_coral_reliquary: { kind: 'moor_stone', name: 'Coral-encrusted relic socket', frame: { w: 140, h: 150 }, band: 'architecture' },
} as const;

export type RuinsPropTemplate = keyof typeof RUINS_PROP_TEMPLATES;
export type TempleLandmarkTemplate = Extract<RuinsPropTemplate, `temple_${string}`>;
export type SunkenLandmarkTemplate = Extract<RuinsPropTemplate, `sunken_${string}`>;
